import React from "react";
import YouTube, { Options } from "react-youtube";
import "./youtube-video.css";
export interface YoutubeVideoProps {
    videoId: string;
    onTimeUpdate: (time: number) => void;
}

export interface YoutubePlayer {
    getCurrentTime(): number;
}

export interface YoutubeVideoState {}

export class YoutubeVideo extends React.Component<
    YoutubeVideoProps,
    YoutubeVideoState
> {
    private player: YoutubePlayer | null = null;
    private interval: NodeJS.Timeout | null = null;

    constructor(props: YoutubeVideoProps) {
        super(props);
    }

    render() {
        const opts = {
            playerVars: {
                modestbranding: 1,
                rel: 0,
            },
        };
        return (
            <div>
                <YouTube
                    videoId={this.props.videoId}
                    opts={opts as Options}
                    onPlay={this._play}
                    onReady={this._ready}
                    onPause={this._pause}
                    onEnd={this._pause}
                    containerClassName={"youtubeContainer"}
                />
            </div>
        );
    }

    _ready = (event: any) => {
        this.player = event.target;
    };

    _play = () => {
        this.interval = setInterval(() => {
            const time = this.player?.getCurrentTime();
            if (time != null) this.props.onTimeUpdate(time);
        }, 100);
    };

    _pause = () => {
        if (this.interval != null) {
            clearTimeout(this.interval);
        }
    };
}
